import { render, staticRenderFns } from "./showAddress.vue?vue&type=template&id=1ff08e16&scoped=true"
import script from "./showAddress.vue?vue&type=script&lang=js"
export * from "./showAddress.vue?vue&type=script&lang=js"
import style0 from "./showAddress.vue?vue&type=style&index=0&id=1ff08e16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff08e16",
  null
  
)

export default component.exports